"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrayPage = void 0;
const __1 = require("../..");
class ArrayPage {
    constructor(elements, start, total) {
        this.elements = [...elements];
        this.start = start;
        this.total = total;
        this.length = this.elements.length;
    }
    get(index) {
        if (index < 0 || index >= this.length) {
            throw new __1.IndexOutOfRangeError(index);
        }
        return this.elements[index];
    }
    toArray() {
        return [...this.elements];
    }
}
exports.ArrayPage = ArrayPage;
//# sourceMappingURL=#array-page.js.map